import SubcategoryPage from '@/components/template/SubcategoryPage';

const StekleniUmivalniki = () => {
  const products = [
    {
      title: "Steklen Umivalnik Oval",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/umivalniki/stekleni/oval"
    },
    {
      title: "Steklen Umivalnik Kvadrat",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/umivalniki/stekleni/kvadrat"
    },
    {
      title: "Steklen Umivalnik Krog",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/umivalniki/stekleni/krog"
    },
    {
      title: "Steklen Umivalnik Premium",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/umivalniki/stekleni/premium"
    },
    {
      title: "Steklen Umivalnik Modern",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/umivalniki/stekleni/modern"
    },
    {
      title: "Steklen Umivalnik Klasik",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/umivalniki/stekleni/klasik"
    }
  ];

  return (
    <SubcategoryPage
      title="Stekleni Umivalniki"
      description="Raziskujte našo kolekcijo elegantnih steklenih umivalnikov, ki združujejo estetsko privlačnost in funkcionalnost. Naši stekleni umivalniki so zasnovani za sodobne kopalnice in ponujajo čist, svetel videz."
      heroImage="https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default StekleniUmivalniki;